import React, { Fragment } from 'react'
import cn from 'classnames'
import styled from '@emotion/styled'
import config from 'config'
import ResizeObserver from 'resize-observer-polyfill'

import SearchKb from 'subapps/ticketing/components/TicketSearchKb'

import ReplyEmailForm from 'components/App/DesktopView/CommunicationForms/Reply/Email'
import ReplyNoteForm from 'components/App/DesktopView/CommunicationForms/Reply/Note'
import ReplyTwitterForm from 'components/App/DesktopView/CommunicationForms/Reply/Twitter'
import ReplyFacebookForm from 'components/App/DesktopView/CommunicationForms/Reply/Facebook'

import styles from './styles.less'
import Commenting from './Commenting'
// leaving this as it needs to be added on flag
import Replying from './Replying'
import AgentCollision from '../AgentCollision'

const Switcher = props => {
  const {
    loaded,
    commenting,
    showKbSearchOnInboxEditor,
    onEditorFormFocus,
    onEditorFormBlur,
    ticketId,
    useDraftsV2,
    useNotesV2,
    isTwitter,
    isFacebook,
  } = props
  const editorProps = {
    ...props,
    onFocus: onEditorFormFocus,
    onBlur: onEditorFormBlur,
  }
  const showCommentEditor = loaded && commenting
  const showOldEditor = isFacebook || !useDraftsV2
  let editor = null
  if (!showCommentEditor && showOldEditor)
    editor = <Replying {...editorProps} />
  if (!showCommentEditor && !showOldEditor)
    editor = (
      <ReplyEmailForm
        ticketId={ticketId}
        onEditorFormFocus={onEditorFormFocus}
        onEditorFormBlur={onEditorFormBlur}
      />
    )
  if (!showCommentEditor && isTwitter)
    editor = (
      <ReplyTwitterForm
        ticketId={ticketId}
        onEditorFormFocus={onEditorFormFocus}
        onEditorFormBlur={onEditorFormBlur}
      />
    )
  if (!showCommentEditor && isFacebook)
    editor = (
      <ReplyFacebookForm
        ticketId={ticketId}
        onEditorFormFocus={onEditorFormFocus}
        onEditorFormBlur={onEditorFormBlur}
      />
    )

  return (
    <Fragment>
      <AgentCollision conversationId={ticketId} />
      {showKbSearchOnInboxEditor === true && (
        <SearchKb className={styles.kbSearch} />
      )}
      {showCommentEditor && !useNotesV2 && <Commenting {...editorProps} />}
      {showCommentEditor &&
        useNotesV2 && (
          <ReplyNoteForm
            ticketId={ticketId}
            onEditorFormFocus={onEditorFormFocus}
            onEditorFormBlur={onEditorFormBlur}
          />
        )}

      {editor}
    </Fragment>
  )
}

const Footer = ({
  className,
  isReplyFormVisible: replying,
  isAddingNote: commenting,
  ticketId,
  ...rest
}) => {
  return (
    <Switcher
      className={cn(className, { commenting })}
      commenting={commenting}
      replying={replying}
      ticketId={ticketId}
      {...rest}
    />
  )
}

const Styled = styled(Footer)`
  background: #fff;
  margin: 0px 24px 12px;
  flex-grow: 0;
  flex-shrink: 0;
  transition: all 200ms ease-in-out;
  z-index: 200;
  min-height: 201px;

  &.commenting {
    background-color: ${props => props.theme.color.secondary.warning};
  }
`

class PositioningAndResizeWrapper extends React.PureComponent {
  componentWillUnmount() {
    this.removeObserver()
  }

  setReference = node => {
    if (node) {
      if (this.observer) this.removeObserver()
      this.node = node
      if (!config.isTest) {
        this.observer = new ResizeObserver(this.handleResize)
        this.observer.observe(node)
      }
      this.lastHeight = node.offsetHeight
      this.hasTriggered = false
    }
  }

  removeObserver() {
    this.isUnmounting = true
    this.observer.disconnect()
    this.observer = null
    this.node = null
    this.lastHeight = null
  }

  handleResize = () => {
    window.requestAnimationFrame(() => {
      if (this.isUnmounting || !this.node) return

      const height = this.node.offsetHeight
      if (height !== this.lastHeight || !this.hasTriggered) {
        const diff = height - this.lastHeight
        this.lastHeight = height
        this.hasTriggered = true
        if (this.props.onResize) this.props.onResize(height, diff)
      }
    })
  }

  render() {
    const { is3ColumnView } = this.props
    return (
      <div
        className={cn(styles.positioning, {
          [styles['positioning-3-column-view']]: is3ColumnView,
        })}
        ref={this.setReference}
      >
        <Styled {...this.props} />
      </div>
    )
  }
}

export default PositioningAndResizeWrapper
